import { FC, useContext, useEffect } from 'react'
import { useMediaQuery } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import isNumber from 'lodash/isNumber'
import { RecruitListScreenContext } from '@app.feature/recruitList/context'
import Pagination from 'components/Pagination'
import { MOBILE_BUTTON_SIZE, PC_BUTTON_SIZE } from 'constants/paginations'
import usePagination from 'hooks/usePagination'

interface RecruitListPaginationProps {
  totalCount: number
}

const PAGE_SIZE = 20

const RecruitListPagination: FC<RecruitListPaginationProps> = ({
  totalCount,
}) => {
  const theme = useTheme()
  const isSMDown = useMediaQuery(theme.breakpoints.down('sm'))
  const { state, dispatch } = useContext(RecruitListScreenContext)
  function setActivePage(newActivePage: number) {
    // @ts-ignore
    dispatch({ type: 'PAGE_UPDATE', page: newActivePage })
  }

  const pagination = usePagination({
    activePage: state.page || 1,
    setActivePage,
    maxButtons: isSMDown ? MOBILE_BUTTON_SIZE : PC_BUTTON_SIZE,
    scrollToTop: true,
  })

  useEffect(() => {
    if (isNumber(totalCount)) {
      pagination.setNumberOfPages(Math.ceil(totalCount / PAGE_SIZE))
      window.scrollTo(0, 0)
    }
  }, [totalCount, state.page])

  return <Pagination pagination={pagination} />
}

export default RecruitListPagination
